module.exports = __webpack_public_path__ + "public/images/icons/shield.b55568fc7a780cc96daa2d4f2b12f237.png";